import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { courseData } from '../mockData';

const FAQ = () => {
  return (
    <section className="py-20" id="faq">
      <div className="container max-w-4xl">
        <div className="text-center mb-12">
          <h2 className="heading-1 mb-4">Frequently Asked Questions</h2>
          <p className="body-large text-secondary">
            Everything you need to know about the course
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {courseData.faq.map((item) => (
            <AccordionItem 
              key={item.id} 
              value={`item-${item.id}`}
              className="bg-card rounded-xl px-6 border border-border"
            >
              <AccordionTrigger className="heading-3 text-left hover:no-underline py-6">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="body-medium text-secondary pb-6">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
